import AnswerList from "components/AnswerList/AnswerList";
import Button from "components/Button/Button";
import Loading from "components/Loading/Loading";
import Logo from "components/Logo/Logo";
import ProgressBar from "components/ProgressBar/ProgressBar";
import Quiz from "components/Quiz/Quiz";
import QuizFooter from "components/QuizFooter/QuizFooter";
import QuizImage from "components/QuizImage/QuizImage";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { appData, appStep, testResult } from "recoil/app";
import style from "./Question.module.scss";

const Question = () => {
  const data = useRecoilValue(appData);
  const setTestResult = useSetRecoilState(testResult);

  const [step, setStep] = useState(1);
  const [input, setInput] = useState<number[]>([]);

  useEffect(() => {
    if (step === data.questionItemList.length + 1) {
      setTestResult(input);
    }
  }, [step]);

  const handleAnswer = useCallback((point: number) => {
    setStep((step) => step + 1);
    setInput((v) => [...v, point]);
  }, []);

  const maxStep = useMemo(() => data && data.questionItemList.length, [data]);

  if (step === data.questionItemList.length + 1) {
    return <Loading />;
  } else {
    const currentStepData = data.questionItemList[step - 1];
    return (
      <div className={style.container}>
        {data.layout === "text" && <Logo />}
        <div className={style.progress_wrapper}>
          <ProgressBar step={step} maxStep={maxStep || 0} />
        </div>

        <div className={style.quiz_image_wrapper}>
          {data.layout !== "text" && (
            <QuizImage step={step} mediaType={data.layout} />
          )}
        </div>
        <Quiz step={step} question={currentStepData.question} />
        <AnswerList
          step={step}
          answerList={currentStepData.answerList}
          handleAnswer={handleAnswer}
        />
        <QuizFooter />
      </div>
    );
  }
};

export default Question;
